<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2lKSyk/images/cover.jpg?1703000774256" alt="This image is the cover for the book Culver City Chronicles, American Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Culver City Chronicles, American Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <p>Culver City has rivaled Hollywood for nearly a century as the "Heart of Screenland"--a center of the movie and television trades. Here, the giant Metro-Goldwyn-Mayer evolved into Sony Pictures, and the Ince and Selznick movie empires became today's Culver Studios. But the same lands along Ballona Creek had been a wilderness traversed by Native Americans and settled by hardy Spanish pioneers named Machado, Talamantes and Higuera. Union soldiers occupied the area's Civil War-era Camp Latham. By 1910, visionary Harry H. Culver saw possibilities for these ranchlands and led Culver City to incorporate in 1917. Join official city historian Julie Lugo Cerra, a descendant of early settlers, as she relates the fascinating stories of how and why Culver City grew and prospered.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Lugo Cerra
      </h2>
      
      <p class="authorDescription body article">Julie Lugo Cerra is a sixth-generation Californian, and a Culver City native who enjoys being called "the accidental historian."?  She was appointed official City historian by the Culver City Council in 1996. Julie, a past president of the Culver City Historical Society, wrote hundreds of articles about her hometown's past in the Culver City News.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26eb16e2